import { useCallback, useEffect, useRef, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { NJButton, NJText } from '@engie-group/fluid-design-system-react';
import PrototypeStudioLayout from '@shared/PrototypeStudioLayout';
import { UMR } from '../../urbanmap/_components';
import { HomePage } from './HomePage';
import { ScenarioSwitcher } from './ScenarioSwitcher';
import { V3Destination } from './V3Destination';
import { useProjects } from './hooks';
import { isHomeScenario } from './homeScenarios';
import type { ProjectSummary } from './types';
import './home.css';

export const meta = {
  title: 'Plan — variantes d’accueil',
  description: 'Cinq états de l’accueil Plan, sélectionnables avec un outil flottant Fluid.',
  tags: ['dashboard', 'planning', 'po'],
  author: 'erika.dalmonte',
  status: 'draft' as const,
  updatedAt: '2026-11-03',
};

export default function PlanAccueilVariantes() {
  const [params, setParams] = useSearchParams();
  const requested = params.get('projets');
  const scenario = isHomeScenario(requested) ? requested : 'mixte';
  const projects = useProjects(scenario);
  const [destination, setDestination] = useState<ProjectSummary | 'create' | null>(null);
  const [toast, setToast] = useState<string | null>(null);
  const timer = useRef<ReturnType<typeof setTimeout>>();
  useEffect(() => {
    if (!document.querySelector(`link[href="${UMR.fontHref}"]`)) {
      const link = document.createElement('link');
      link.rel = 'stylesheet'; link.href = UMR.fontHref; document.head.appendChild(link);
    }
    return () => clearTimeout(timer.current);
  }, []);
  const flash = useCallback((message: string) => {
    setToast(message); clearTimeout(timer.current);
    timer.current = setTimeout(() => setToast(null), 3200);
  }, []);
  const open = useCallback((id: string) => {
    const project = projects.data?.find((item) => item.id === id);
    if (project) setDestination(project);
  }, [projects.data]);
  return (
    <>
      <PrototypeStudioLayout title={meta.title}>
        <div className="pav-root" data-comment-view="home" data-scenario={scenario}>
          <HomePage key={scenario} projects={projects.data} loading={projects.isLoading} error={projects.isError}
            onCreate={() => setDestination('create')} onOpen={open} flash={flash} />
          {projects.isError && <div className="pav-retry">
            <NJButton label="Réessayer" icon="refresh" variant="secondary" onClick={() => void projects.refetch()} />
          </div>}
          {toast && <div className="pav-toast" role="status"><NJText scale="sm">{toast}</NJText></div>}
        </div>
      </PrototypeStudioLayout>
      <ScenarioSwitcher value={scenario} onChange={(next) => {
        setDestination(null);
        setParams((current) => { const updated = new URLSearchParams(current); updated.set('projets', next); return updated; });
      }} />
      {destination && <V3Destination project={destination} onClose={() => setDestination(null)} />}
    </>
  );
}
